import { render } from "./CommsSection.vue?vue&type=template&id=b23de910"
import script from "./CommsSection.vue?vue&type=script&lang=js"
export * from "./CommsSection.vue?vue&type=script&lang=js"
script.render = render

export default script